module.exports = Roo.locales['ur'];